import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default class DataExportReducer {
    static BuildingReducer(state = initialState.DataExport, action){
        switch(action.type){
            case types.GET_ALL_BUILDINGS_LIST: return {
                ...state, Buildings: action.getResponse,
            };
            default: return state;
        }
    }

    static FamilyTypeReducer(state = initialState.DataExport, action){
        switch (action.type) {
            case types.GET_ALL_FAMILY_TYPES_LIST: return {
                ...state, FamilyTypes: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static EquipmentListReducer(state = initialState.DataExport, action){
        switch (action.type) {
            case types.GET_BUILDINGS_FAMILY_TYPES_EQUIPMENT: return {
                ...state, EquipmentList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static EquipmentPropertiesReducer(state = initialState.DataExport, action){
        switch (action.type) {
            case types.GET_EQUIPMENT_PROPERTIES_LIST: return {
                ...state, EquipmentPropertiesList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static DataExportDatalogDefinitionsReducer(state = initialState.DataExport, action){
        switch (action.type) {
            case types.GET_DATALOG_DEFINITIONS_LIST: return {
                ...state, DatalogDefinitions: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static DataSourceReducer(state = initialState.DataExport, action){
        switch(action.type){
            case types.GET_DATASOURCE_DETAILS: return{
                ...state, DataSource: action.getResponse,
            };
            default: return state;
        }
    }
}